import React, { useState } from "react"
import OpCard from "@/common/components/OpCard"
import styled from "styled-components"
import { useTranslation } from "next-i18next"

export default function OpCards({ data, filer }) {
  const [opcard, setOpcard] = useState("")
  const { t } = useTranslation("joinUs")
  const parsedData = data.filter(d => d.tab.includes(filer))

  return (
    <Wrapper>
      {parsedData.map(({ title, desc, id, content, table }) => (
        <OpCard
          key={id}
          id={id}
          title={t(title)}
          desc={t(desc)}
          content={content}
          table={table}
          opcard={opcard}
          setOpcard={setOpcard}
        />
      ))}
    </Wrapper>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["joinUs", "common"]))
  }
})

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;
`
